import React, { useEffect, useState } from 'react';
import NestwarsLogo from './images/nestwarslogo.png';
import NestLogo from './images/antcnestimage.png';
import { doc, setDoc, arrayUnion, runTransaction, getDoc, getDocs, collection, updateDoc } from 'firebase/firestore';
import { db } from './firebaseConfig'; // Import your Firebase configuration
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import Gold from './images/TrophyG.png';
import Silver from './images/TrophyS.png';
import Bronze from './images/TrophyB.png';

function getOrdinal(n) {
  var s = ["th", "st", "nd", "rd"],
      v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function Nestwars({ changeActiveComponent }) {
  const { wallet } = useSolanaWeb3();
  const [loading, setLoading] = useState(true);
  const [userNest, setUserNest] = useState(null);
  const [triggerRefresh, setTriggerRefresh] = useState(0); // State to trigger a refresh
  const [isJoiningNest, setIsJoiningNest] = useState(false);
  const [selectedTaskCategory, setSelectedTaskCategory] = useState('platform');
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [userPoints, setUserPoints] = useState(0);
  const [userTasksCompleted, setUserTasksCompleted] = useState(0);
  const [nestPoints, setNestPoints] = useState(0);
  const [nestTasksCompleted, setNestTasksCompleted] = useState(0);

  useEffect(() => {
    // Existing useEffect for checking user's nest
    const checkUserNest = async () => {
      setLoading(true); // Optionally manage loading state here
      if (wallet.connected && wallet.publicKey) {
        const walletAddress = wallet.publicKey.toString();
        const userDocRef = doc(db, "users", walletAddress);
  
        try {
          const docSnap = await getDoc(userDocRef);
          if (docSnap.exists() && docSnap.data().nest) {
            setUserNest(docSnap.data().nest);
          } else {
            setUserNest(null);
          }
        } catch (error) {
          console.error("Error checking user's nest:", error);
        }
      }
      setLoading(false);
    };
  
    checkUserNest();
  }, [wallet, triggerRefresh]);

  useEffect(() => {
    const fetchUserAndNestData = async () => {
      if (wallet.connected && wallet.publicKey) {
        const walletAddress = wallet.publicKey.toString();
        const userDocRef = doc(db, "users", walletAddress);
  
        try {
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            const userNestId = userDocSnap.data().nest;
            setUserNest(userNestId); // Set user's nest for other uses
  
            // Fetch user's points and tasks completed from the nest subcollection
            const userInNestDocRef = doc(db, "nests", userNestId, "users", walletAddress);
            const userInNestDocSnap = await getDoc(userInNestDocRef);
            if (userInNestDocSnap.exists()) {
              const userData = userInNestDocSnap.data();
              setUserPoints(userData.points);
              setUserTasksCompleted(userData.tasksCompleted);
  
              // Update the tasks list with the new completion status for specific tasks
              setTasks(prevTasks => prevTasks.map(task => {
                if (task.id === 't6') {
                  return { ...task, completed: userData.basicAntsBought || 0 };
                } else if (task.id === 't7') {
                  return { ...task, completed: userData.premiumAntsBought || 0 };
                }
                return task;
              }));
            }
  
            // Fetch nest's total points and total tasks completed
            const nestDocRef = doc(db, "nests", userNestId);
            const nestDocSnap = await getDoc(nestDocRef);
            if (nestDocSnap.exists()) {
              setNestPoints(nestDocSnap.data().PTS);
              setNestTasksCompleted(nestDocSnap.data().tasksCompleted);
            }
          }
        } catch (error) {
          console.error("Error fetching user and nest data:", error);
        }
      }
    };
  
    fetchUserAndNestData();
  }, [wallet, triggerRefresh]);
  
  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "nests"));
        const nestData = [];
        querySnapshot.forEach((doc) => {
          // Use doc.id to get the nest's name (since the name is the document ID)
          const name = doc.id;
          const PTS = doc.data().PTS; // Assuming PTS is directly a field in the document
          nestData.push({ name, PTS });
        });
        // Sort nests by points in descending order
        const sortedNests = nestData.sort((a, b) => b.PTS - a.PTS);
        setLeaderboardData(sortedNests);
      } catch (error) {
        console.error("Error fetching nests data:", error);
      }
    };
  
    fetchLeaderboardData();
  }, []);

  // Placeholder components for user's nestwars component
  const UserNestComponent = () => (
    <div>
      <h1>Welcome to your Nest</h1>
      <p>You are already part of a nest. Here's your community!</p>
      {/* Add more components or details related to the user's nest */}
    </div>
  );

  const [tasks, setTasks] = useState([
    { id: 't1', name: 'FOLLOW TWITTER', points: 10, category: 'external', completed: 0, total: 1 },
    { id: 't2', name: 'FOLLOW TWITTER', points: 10, category: 'external', completed: 0, total: 1 },
    { id: 't3', name: 'FOLLOW TWITTER', points: 10, category: 'external', completed: 0, total: 1 },
    { id: 't4', name: 'FOLLOW TWITTER', points: 10, category: 'external', completed: 0, total: 1 },
    { id: 't5', name: 'LEVEL UP YOUR ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    { id: 't6', name: 'BUY NEW BASIC ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    { id: 't7', name: 'OBTAIN NEW PREMIUM ANT', points: 10, category: 'platform', completed: 0, total: 40 },
    { id: 't8', name: 'LEVEL UP YOUR ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    { id: 't9', name: 'LEVEL UP YOUR ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    { id: 't10', name: 'LEVEL UP YOUR ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    { id: 't11', name: 'LEVEL UP YOUR ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    { id: 't12', name: 'LEVEL UP YOUR ANT', points: 1, category: 'platform', completed: 0, total: 40 },
    // Add more tasks here...
  ]);

  const handleTaskCategoryClick = (category) => {
    setSelectedTaskCategory(category);
  };

  const filteredTasks = tasks.filter(task => task.category === selectedTaskCategory);

  const infoData = {
    id: 'info',
    logo: NestwarsLogo,
    title: 'What is NestWars?',
    content: (
      <>
        <p>
          Nest Wars is a competition designed to foster alliances and celebrate collective successes, where each project involved is considered a unique "Nest" with untapped potential.
        </p>
        <p>
          The members of each community play a very important role since each one contributes to the success of their nest, earning points by completing various tasks.
        </p>
        <p>
          The Kingdom of ANTS challenges you to guide your nest into battle and aim for triumph.
        </p>
      </>
    )
  };
  const [selectedItem, setSelectedItem] = useState(infoData.id);
  const nests = [
      {
          id: 'antc',
          logo: NestLogo,
          title: '$ANTC',
          content: 'Loremmi impusimLoremmi impusimLoremmi impusim Loremmi impusim Loremmi impusim .'
          // More nest details here
      },
      {
        id: 'banc',
        logo: NestwarsLogo,
        title: '$BA2',
        content: 'Information about BANC Nest...'
        // More nest details here
    },
    {
      id: 'banc2',
      logo: NestwarsLogo,
      title: '$BANC3',
      content: 'Information about BANC Nest...'
      // More nest details here
  },
  {
    id: 'banc3',
    logo: NestwarsLogo,
    title: '$BANC4',
    content: 'Information about BANC Nest...'
    // More nest details here
},
{
  id: 'banc4',
  logo: NestwarsLogo,
  title: '$BANC5',
  content: 'Information about BANC Nest...'
  // More nest details here
},
{
  id: 'bancs',
  logo: NestwarsLogo,
  title: '$BANC6',
  content: 'Information about BANC Nest...'
  // More nest details here
},
{
  id: 'banc5',
  logo: NestwarsLogo,
  title: '$BANC7',
  content: 'Information about BANC Nest...'
  // More nest details here
},
{
  id: 'banc6',
  logo: NestwarsLogo,
  title: '$BANC8',
  content: 'Information about BANC Nest...'
  // More nest details here
},
      // ... other nests
  ];

  const handleItemClick = (nestId) => {
      setSelectedItem(nestId);
  };

  const getActiveContent = () => {
    if (selectedItem === infoData.id) {
      return infoData;
    }
    return nests.find(nest => nest.id === selectedItem);
};

const joinNest = async (nestId) => {
  if (wallet.connected && wallet.publicKey && !isJoiningNest) {
    setIsJoiningNest(true);
    const walletAddress = wallet.publicKey.toString();

    // First, update the user's document to indicate their chosen nest.
    const userDocRef = doc(db, "users", walletAddress);
    try {
      await setDoc(userDocRef, { nest: nestId }, { merge: true });
      console.log(`Updated user's nest to ${nestId}`);
    } catch (error) {
      console.error("Error updating user's nest:", error);
      setIsJoiningNest(false);
      return; // Exit if unable to update user's nest choice
    }

    // Then, add or update the user in the nest's subcollection of users.
    const userInNestDocRef = doc(db, "nests", nestId, "users", walletAddress);
    try {
      await setDoc(userInNestDocRef, { points: 0, tasksCompleted: 0 }, { merge: true }); // Example initial data
      console.log(`User ${walletAddress} added to nest ${nestId} subcollection`);
    } catch (error) {
      console.error("Error adding user to nest subcollection:", error);
    }

    setIsJoiningNest(false);
    setTriggerRefresh(prev => prev + 1); // Trigger any necessary state updates or re-renders
  } else {
    console.error('Wallet is not connected or already joining a nest');
  }
};

const nestRank = userNest ? getOrdinal(leaderboardData.findIndex(nest => nest.name === userNest.name) + 1) : 'Not part of a nest';

const calculatePercentage = (userPts, nestPts) => {
  return ((userPts / nestPts) * 100).toFixed(1); // toFixed(1) will round to 1 decimal place
};

const getNestRank = (nestName, leaderboard) => {
  // Make sure leaderboard data is loaded and nestName is valid
  if (!leaderboard || !nestName) {
    console.log("Leaderboard data or nestName is not ready:", {leaderboard, nestName});
    return null;
  }
  const rank = leaderboard.findIndex(nest => nest.name === nestName) + 1;
  if (rank === 0) {
    console.log("Nest not found in leaderboard data:", nestName);
    return null; // Nest not found
  }
  return rank;
};

if (loading) {
  return (
    <div className="nestwars-container">
      <img className="nestwars-logo" src={NestwarsLogo} alt="Nestwars" />
      <p>Loading...</p>
    </div>
  );
}

if (userNest) {
  return (
    <section id="nestwars">
      <div className="nestwars-container">
        <img className="nestwars-logo" src={NestwarsLogo} alt="Nestwars" />
        <div className="platform-container" id="nestwars-platform">
          <div className="platform-left-container" id="nestwars-user-tasks">
          <div className="platform-task-header-container">
              <div 
                className={`platform-task-container ${selectedTaskCategory === 'platform' ? '' : 'not-active'}`} 
                id="platformtasks-container" 
                onClick={() => handleTaskCategoryClick('platform')}
              >
                <h2>PLATFORM TASKS</h2>
              </div>
              <div 
                className={`platform-task-container ${selectedTaskCategory === 'external' ? '' : 'not-active'}`} 
                id="external-container" 
                onClick={() => handleTaskCategoryClick('external')}
              >
                <h2>EXTERNAL TASKS</h2>
              </div>
            </div>
            <div className="active-tasks-container">
              <div className="line"></div>
              <p>ACTIVE</p>
              <div className="line"></div>
            </div>
            <div className="nestwars-tasks-container">
              {filteredTasks.map((task) => (
                <div key={task.id} className="nestwars-task-container">
                  <div className="nestwars-task-text-container">
                    <h3>{task.name}</h3>
                    <p>{task.points} PTS</p>
                  </div>
                  <div className="nestwars-complete-task-container">
                    {task.category === 'external' ? (
                      <button className="complete-task-button">CLAIM REWARD</button>
                    ) : (
                      <h3>{`${task.completed}/${task.total}`}</h3>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="active-nest-right-container">
            <div className="active-nest-right-container-up">
              <div className="leaderboard-header-container">
                <div className="leaderboard-header-texts">
                  <h2>LEADERBOARD</h2>
                  <p>End in: 29 days</p>
                </div>
                <div className="leaderboard-logo"><img src={NestwarsLogo}></img></div>
              </div>
              <div className="leaderboard-container">
  {leaderboardData.slice(0, 4).map((nest, index) => (
    <div key={index} className="leader-container" id={`positions-${index + 1}`}>
      <div className="position-img-cont">
        {index < 3 ? (
          <img src={index === 0 ? Gold : index === 1 ? Silver : index === 2 ? Bronze : null} alt="Trophy" />
        ) : (
          <p>04</p> // Displaying text for the fourth place
        )}
      </div>
      <div className="leaderboard-team">
        <img src={NestLogo} alt="Nest" />
        <p id={`position-${index + 1}`}>${nest.name}</p>
      </div>
      <div id="nestpoints"><p>{nest.PTS} PTS</p></div>
    </div>
  ))}
</div>
            </div>
            <div className="active-nest-right-container-down">
            <div className="nestinfo-header-container">
            <div className="nestinfo-text-container"><h2>WARRIOR/NEST INFO</h2><p>Last updated: 02.02.2032</p><p id="infotextnest">For NestWars I'm thinking we add button somewhere this is something you guys can decide where it would be good to add to head over nestwars section.</p></div>
            <div className="nestinfo-image-container"><img src={NestLogo}></img></div>
            </div>
            <div className="nestinfo-stats-container">
            <div className="nestinfo-stat-container"><h3>YOUR PTS</h3><div className="nestinfo-stat"><h2>{userPoints}</h2><p>({userPoints && nestPoints ? `${calculatePercentage(userPoints, nestPoints)}%` : "Calculating..."})</p></div></div>
            <div className="nestinfo-stat-container"><h3>NEST PTS</h3><div className="nestinfo-stat"><h2>{nestPoints}</h2><p>({getOrdinal(getNestRank(userNest, leaderboardData))})</p></div></div>
            <div className="nestinfo-stat-container"><h3>TASKS COMPLETED</h3><div className="nestinfo-stat"><h2>{userTasksCompleted}</h2><p>/120</p></div></div>
            <div className="nestinfo-stat-container"><h3>NEST'S TASKS</h3><div className="nestinfo-stat"><h2>{nestTasksCompleted}</h2><p>/1800</p></div></div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

  return (
    <section id="nestwars">
        <div className="nestwars-container">
            <img className="nestwars-logo" src={NestwarsLogo} alt="Nestwars" />
            <div className="platform-container" id="nestwars-platform">
                <div className="platform-left-container">
                    <div className="nest-wars-texts">
                        <h1>CHOOSE YOUR NEST</h1>
                        <p>
The battle for supremacy is not just a game. It is a way of life. Here, choosing your nest is the first step to defining your destiny.
<br></br><br></br>
Each nest represents a unique faction with its own culture and abilities. Being part of a nest means embracing your identity, collaborating, and fighting for collective glory.
<br></br><br></br>
The goal is clear: Raise your nest to the top and claim the $10,000 jackpot.
<br></br><br></br>
Will your nest soar to victory or fall in the great Nest Wars? The choice is yours.
</p>
                    </div>
                    <div className="nest-wars-nests">
                        {nests.map((nest) => (
                            <div 
                                key={nest.id} 
                                className={`nest-wars-nest ${selectedItem === nest.id ? 'selected' : ''}`}
                                onClick={() => handleItemClick(nest.id)}
                            >
                                <div className="nest-wars-nest-image">
                                    <img src={nest.logo} alt={nest.title} />
                                </div>
                                <p>{nest.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="platform-right-container">
                    {selectedItem && (
                        <div className="nest-wars-active-nest-container">
                          <div className="nest-wars-nest-image-big">
                          <img src={getActiveContent().logo} alt={getActiveContent().title} />
                                </div>
                                <div className="nest-wars-nest-active-text">
                                <h2>{getActiveContent().title}</h2>
                        <p>{getActiveContent().content}</p>
                        {selectedItem !== infoData.id && (
                          <button className="join-nest-button" onClick={() => joinNest(getActiveContent().id)} disabled={isJoiningNest}>
                             {isJoiningNest ? 'Joining...' : `JOIN ${getActiveContent().title} TEAM`}
                          </button>
                        )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </section>
);
}

export default Nestwars;